<template>
  <div class="main-content" :style="diyStyle" :class="{'flex-col':isFlexCol}">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    diyStyle: Object,
    isFlexCol: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
  .main-content {
    flex: 1;
    width: 100%;
    height: 100%;
    background-color: $color-white;
    padding: 0 20px;
  }
  .flex-col {
    display: flex;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout-container/main/main-content.vue